import { Resume } from "@/types/resume/v1"
import { IParagraphStylePropertiesOptions } from "docx/build/file/paragraph/properties"

const LineHeightMap = {
  single: 240, // 1.0
  default: 276, // 1.15
  spacious: 360 // 1.5
}

export const getParagraphStyle = (meta?: Resume.Meta): IParagraphStylePropertiesOptions => {
  const lineHeight = meta?.lineHeight || 'default'
  const lineSpacing = LineHeightMap[lineHeight] || LineHeightMap['default']

  return {
    spacing: {
      line: lineSpacing,
    },
  }
}
